"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _socket = _interopRequireDefault(require("socket.io-client"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SocketStream = /*#__PURE__*/function () {
  function SocketStream(_ref) {
    var auth = _ref.auth,
        url = _ref.url;

    _classCallCheck(this, SocketStream);

    this.auth = auth;
    this.url = url;
    return this.init();
  }

  _createClass(SocketStream, [{
    key: "init",
    value: function init() {
      var _this = this;

      var isReinitializing = false;

      if (this.socket) {
        isReinitializing = true;
        this.destroy();
      }

      this.authorized = false;
      this.subscriptions = [];
      this.socket = (0, _socket.default)(this.url, {
        transports: ['websocket']
      });
      this.socket.on('reconnect_attempt', function () {
        _this.socket.io.opts.transports = ['polling', 'websocket'];
      });
      this.socket.on('unauthorized', this.on_unauthorized());
      this.socket.on('authorized', this.on_authorized());
      this.socket.on('connect', this.on_connect(isReinitializing));
      this.socket.on('disconnect', function () {
        return _this.init();
      });
      this.socket.on('didSubscribe', this.on_didSubscribe());
      this.socket.on('didUnsubscribe', this.on_didUnsubscribe());
      this.bindAdditionalEvents();
      return this;
    }
  }, {
    key: "bindAdditionalEvents",
    value: function bindAdditionalEvents() {// override this
    }
  }, {
    key: "authenticate",
    value: function authenticate() {
      var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.auth.getToken();
      this.socket.emit('authenticate', {
        token: token
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.socket.destroy();
    }
  }, {
    key: "on_connect",
    value: function on_connect() {
      var _this2 = this;

      return function () {
        _this2.authenticate();
      };
    }
  }, {
    key: "on_authorized",
    value: function on_authorized() {
      var _this3 = this;

      return function () {
        _this3.authorized = true;
      };
    }
  }, {
    key: "on_didSubscribe",
    value: function on_didSubscribe() {
      var _this4 = this;

      return function (payload) {
        var subscriptionId = payload.room;

        if (_this4.subscriptions.indexOf(subscriptionId) === -1) {
          _this4.subscriptions.push(subscriptionId);
        }
      };
    }
  }, {
    key: "on_didUnsubscribe",
    value: function on_didUnsubscribe() {
      var _this5 = this;

      return function (payload) {
        _this5.subscriptions = _this5.subscriptions.filter(function (name) {
          return name !== payload.room;
        });
      };
    }
  }, {
    key: "isAuthorized",
    value: function isAuthorized() {
      var _this6 = this;

      return new Promise(function (resolve) {
        if (_this6.authorized) {
          return resolve(_this6.authorized);
        }

        _this6.socket.on('authorized', resolve);
      });
    }
  }, {
    key: "on_unauthorized",
    value: function on_unauthorized() {
      var _this7 = this;

      return function (authErr) {
        _this7.authorized = false;

        if (authErr && authErr.message && authErr.message.match(/expired/ig)) {
          _this7.auth.renewAuth().then(function () {
            return _this7.init();
          });
        }
      };
    }
  }]);

  return SocketStream;
}();

var _default = SocketStream;
exports.default = _default;